export const environment = {
	production: false,
	apiUrl: 'https://api-staging.kbmhawaii.com/api/2.6',
	yieldMaxApiUrl: 'https://yieldmax.io/api/2.6',
	atlRptApiUrl: 'https://atl-rpt.kbmhawaii.com/api/2.6',
	nycRptApiUrl: 'https://nyc-rpt.kbmhawaii.com/api/2.6',
	referringUrl: 'staging.admin.kbmhawaii.com',
	kbmResortsURL: 'https://www.kbmresorts.com',
	kbmAdminURL: 'https://staging.admin.kbmhawaii.com'
};
